import { render, staticRenderFns } from "./MarketingAction.vue?vue&type=template&id=6f5719ba&"
import script from "./MarketingAction.vue?vue&type=script&lang=ts&"
export * from "./MarketingAction.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports